import { useSelector } from 'react-redux';

import { Snackbar as MuiSnackbar, Alert } from '@mui/material';

import { IRootState } from 'src/components/common/types/snackbarTypes';
import { store } from 'src/store';

import { hideSnackbar, showSnackbar } from './snackbarSlice';

export const snackbar = (
	message: string,
	severity: IRootState['snackbar']['severity'],
	position: IRootState['snackbar']['position'] = 'right',
) => {
	store.dispatch(
		showSnackbar({
			message,
			severity,
			open: true,
			id: Date.now(),
			position: position,
		}),
	);
};

const Snackbar: React.FC = () => {
	const { message, severity, open, id, position } = useSelector(
		(state: IRootState) => state.snackbar,
	);

	const handleClose = () => {
		store.dispatch(hideSnackbar());
	};

	return (
		<MuiSnackbar
			key={id}
			open={open}
			autoHideDuration={6000}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: position || 'right',
			}}
		>
			<Alert
				onClose={handleClose}
				severity={severity}
				sx={{ width: '100%' }}
				variant='standard'
			>
				{message}
			</Alert>
		</MuiSnackbar>
	);
};

export default Snackbar;
